// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"cebe7535","188":"205946b3","193":"91d1a9db","202":"205946b3","700":"bb9f9c7c","940":"e2b2bd1d","954":"c99a1cc0"}[chunkId] + ".chunk.css";
};